<script>

import Grid from "../../../frontend/src/components/Grid"

export default Grid
</script>